<template>
  <section class="app-download-cta">
    <div class="app-download-cta__inner">
      <h2 class="app-download-cta__title">Get $5 off your next Style Cut</h2>
      <p class="app-download-cta__sub">Download the Just Cuts app and save on every visit.</p>

      <!-- TODO: swap href values for real App Store / Google Play URLs and replace inline SVG with official badge artwork -->
      <div class="app-download-cta__buttons">
        <a class="app-download-cta__badge" href="#" aria-label="Download on the App Store">
          <svg class="app-download-cta__badge-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M16.5 12.6c0-2.4 2-3.5 2.1-3.6-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.6.9-.7 0-1.9-.9-3.1-.9-1.6 0-3.1.9-3.9 2.4-1.7 2.9-.4 7.2 1.2 9.5.8 1.1 1.8 2.4 3 2.4 1.2 0 1.7-.8 3.1-.8 1.5 0 1.8.8 3.1.8 1.3 0 2.1-1.2 2.9-2.3.9-1.3 1.3-2.6 1.3-2.7-.1-.1-2.6-1-2.6-3.8zM14.5 5.4c.7-.8 1.1-1.9 1-3-1 0-2.2.6-2.9 1.4-.6.7-1.2 1.8-1 2.9 1.1.1 2.2-.5 2.9-1.3z"/>
          </svg>
          <span class="app-download-cta__badge-text">
            <span class="app-download-cta__badge-small">Download on the</span>
            <span class="app-download-cta__badge-store">App Store</span>
          </span>
        </a>

        <a class="app-download-cta__badge" href="#" aria-label="Get it on Google Play">
          <svg class="app-download-cta__badge-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M3.6 2.5c-.4.4-.6 1-.6 1.7v15.6c0 .7.2 1.3.6 1.7l9-9-9-9zm10.4 7.6L5.7 1.9 16.5 8l-2.5 2.1zM5.7 22.1l8.3-8.2 2.5 2.1-10.8 6.1zm15.7-11.6L18 8.6l-2.7 2.4 2.7 2.4 3.4-1.9c.9-.5.9-1.6 0-2z"/>
          </svg>
          <span class="app-download-cta__badge-text">
            <span class="app-download-cta__badge-small">Get it on</span>
            <span class="app-download-cta__badge-store">Google Play</span>
          </span>
        </a>
      </div>
    </div>
  </section>
</template>


<script>

export default {

}
</script>
